import React, { useEffect } from 'react'
import Plus from '@components/Icons/Plus.jsx'
import Minus from '@components/Icons/Minus.jsx'
import AngleLeft from '@components/Icons/AngleLeft.jsx'
import CloseX from '@components/Icons/Close-X.jsx'
import * as nav from '@data/navdata'

const SubnavNursery = ({
    activeSubnav,
    handleToggleSubnav,
    activeSubSubnav = { gear: true },
    setActiveSubSubnav,
    handleToggleSubSubnav,
    handleCloseMenu,
}) => {
    useEffect(() => {
        // Set Gear section as expanded when component mounts
        if (setActiveSubSubnav) {
            setActiveSubSubnav({ ...activeSubSubnav, gear: true })
        }
    }, []) // Empty dependency array means this runs once on mount

    return (
        <nav
            className={`subnav-wrap w-full h-full bg-[#FFFAF5]`}
            role="navigation"
        >
            <div className="mobile-subnav-header flex items-center w-full sticky top-0 bg-[#FFFAF5]">
                <div
                    className="subnav-nav-back cursor-pointer p-3 relative left-2 z-10 w-[32px]"
                    onClick={handleToggleSubnav}
                    data-nav="nursery"
                >
                    <AngleLeft width="w-[12px]" />
                </div>
                <h2 className="text-center text-2xl flex-1 relative -left-[24px]">
                    Nursery + Gear
                </h2>
                <div
                    onClick={handleCloseMenu}
                    className="mobile-menu-close flex absolute items-center justify-end text-center right-4 top-3"
                >
                    <span className="close-x menu-close relative top-[5px] !font-bold">
                        <CloseX width="w-[16px]" />
                    </span>
                </div>
            </div>
            <div
                className="subsubnav subnav-nursery-health-safety bg-[#FFFAF5] py-3 border-t border-oat"
                data-subnav="gear"
            >
                <div
                    className="menu-section-header flex items-center w-full py-1"
                    data-subnav="gear"
                    onClick={handleToggleSubSubnav}
                >
                    <span
                        className={`menu-section-text pl-6 text-lg ${
                            activeSubSubnav && activeSubSubnav.gear === true
                                ? 'pb-3'
                                : ''
                        }`}
                    >
                        Gear
                    </span>{' '}
                    <span className="ml-auto mr-5">
                        {activeSubSubnav && activeSubSubnav.gear === true ? (
                            <Minus width="w-[16px]" />
                        ) : (
                            <Plus width="w-[18px]" />
                        )}
                    </span>
                </div>
                <div
                    className={`subsubnav subsubnav-nursery-furniture-decor ${
                        activeSubSubnav && activeSubSubnav.gear
                            ? 'block'
                            : 'hidden'
                    }`}
                    data-subsubnav="gear"
                >
                    <ul className="nostyle">
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.gear_travel}>
                                Shop All Gear
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.travel_systems}>
                                Travel Systems
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.strollers}>
                                Strollers
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.car_seats}>
                                Car Seats
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.high_chairs}>
                                High Chairs
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.bouncers_loungers}>
                                Bouncers + Loungers
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.travel_cribs_play_yards}>
                                Travel Cribs + Play Yards
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.carriers}>
                                Carriers
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.bathing}>
                                Bath + Accessories
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.diaper_bags}>
                                Diaper Bags + Accessories
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.plates_cups}>
                                Feeding Accessories
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.activity_centers_play_gyms}>
                                Play Gyms + Mats
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                className="subsubnav subnav-nursery-furniture-decor bg-[#FFFAF5] py-3 border-t border-oat"
                data-subnav="nursery"
            >
                <div
                    className="menu-section-header flex items-center w-full py-1"
                    data-subnav="nursery"
                    onClick={handleToggleSubSubnav}
                >
                    <span
                        className={`menu-section-text pl-6 text-lg ${
                            activeSubSubnav && activeSubSubnav.nursery === true
                                ? 'pb-3'
                                : ''
                        }`}
                    >
                        Nursery
                    </span>{' '}
                    <span className="ml-auto mr-5">
                        {activeSubSubnav && activeSubSubnav.nursery === true ? (
                            <Minus width="w-[16px]" />
                        ) : (
                            <Plus width="w-[18px]" />
                        )}
                    </span>
                </div>
                <div
                    className={`subsubnav subsubnav-nursery-furniture-decor ${
                        activeSubSubnav && activeSubSubnav.nursery
                            ? 'block'
                            : 'hidden'
                    }`}
                    data-subsubnav="nursery"
                >
                    <ul className="nostyle">
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.nursery}>
                                Shop All Nursery
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.cribs_bassinets}>
                                Cribs
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.dressers}>
                                Dressers
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.gliders}>
                                Gliders + Rocking Chairs
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.rugs_storage}>
                                Rugs + Storage
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.bedding}>
                                Mattresses + Bedding
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.changing_pads}>
                                Changing Pads
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.sound_machines}>
                                Sound Machines + Monitors
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                className="subsubnav subnav-nursery-furniture-decor bg-[#FFFAF5] py-3 border-t border-oat"
                data-subnav="toys"
            >
                <div
                    className="menu-section-header flex items-center w-full py-1"
                    data-subnav="toys"
                    onClick={handleToggleSubSubnav}
                >
                    <span
                        className={`menu-section-text pl-6 text-lg ${
                            activeSubSubnav && activeSubSubnav.toys === true
                                ? 'pb-3'
                                : ''
                        }`}
                    >
                        Toys
                    </span>{' '}
                    <span className="ml-auto mr-5">
                        {activeSubSubnav && activeSubSubnav.toys === true ? (
                            <Minus width="w-[16px]" />
                        ) : (
                            <Plus width="w-[18px]" />
                        )}
                    </span>
                </div>
                <div
                    className={`subsubnav subsubnav-nursery-furniture-decor ${
                        activeSubSubnav && activeSubSubnav.toys
                            ? 'block'
                            : 'hidden'
                    }`}
                    data-subsubnav="toys"
                >
                    <ul className="nostyle">
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.toys}>
                                Shop All Toys
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.baby_toys}>
                                Baby Toys
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.toddler_toys}>
                                Toddler Toys
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.kids_toys}>
                                Kids Toys
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.plush_toys}>
                                Plush Toys
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.wooden_toys}>
                                Wooden Toys
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.silicone_toys}>
                                Silicone Toys
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.play_furniture}>
                                Play Furniture
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.memory_books}>
                                Memory Books
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                className="subsubnav subnav-nursery-furniture-decor bg-[#FFFAF5] py-3 border-t border-oat"
                data-subnav="featured_collections"
            >
                <div
                    className="menu-section-header flex items-center w-full py-1"
                    data-subnav="featured_collections"
                    onClick={handleToggleSubSubnav}
                >
                    <span
                        className={`menu-section-text pl-6 text-lg ${
                            activeSubSubnav &&
                            activeSubSubnav.featured_collections === true
                                ? 'pb-3'
                                : ''
                        }`}
                    >
                        Featured Collections
                    </span>{' '}
                    <span className="ml-auto mr-5">
                        {activeSubSubnav &&
                        activeSubSubnav.featured_collections === true ? (
                            <Minus width="w-[16px]" />
                        ) : (
                            <Plus width="w-[18px]" />
                        )}
                    </span>
                </div>
                <div
                    className={`subsubnav subsubnav-nursery-furniture-decor ${
                        activeSubSubnav && activeSubSubnav.featured_collections
                            ? 'block'
                            : 'hidden'
                    }`}
                    data-subsubnav="featured_collections"
                >
                    <ul className="nostyle">
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.brands_we_love}>
                                Shop All Brands We Love
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.baby_registry_essentials}>
                                Shop Registry Essentials
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.sleep_essentials}>
                                Shop Sleep Essentials
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.diapering}>
                                Shop Diapering
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.nursing_feeding}>
                                Shop All Feeding
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.bathing}>
                                Shop All Bathing
                            </a>
                        </li>
                        <li className="pl-6 py-3 border-t border-oat font-normal">
                            <a className="block" href={nav.accessories}>
                                Shop All Accessories
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default SubnavNursery
